<template>
  <div class="text-center py-5 white-text">
    PÁGINA NÃO ENCONTRADA
  </div>
</template>

<script>
export default {
  name: 'UserError404'
}
</script>

<style scoped>

</style>
